import { FormInstance } from 'antd';
import { isRealHts } from '@xbcb/entry-utils/dist/lib/htsUtil';
import { NamePath } from '@xbcb/ui-types';

export const getRealTariffIndex = (
  form: FormInstance,
  linesNamePath: NamePath,
): number | undefined => {
  const lines = form.getFieldValue(linesNamePath) || [];
  if (lines.length !== 1) return undefined;

  const { tariffs } = lines[0];
  if (!tariffs || tariffs.length === 0) return undefined;

  if (tariffs.length === 1) return 0;

  for (let i = 0; i < tariffs.length; i++) {
    if (isRealHts(tariffs[i]?.htsNumber)) {
      return i;
    }
  }

  return undefined;
};
